<script setup>
import { ref } from 'vue';
import { useVModel } from '@vueuse/core';
import LabelDestinatario from './LabelDestinatario.vue';
import { doubleRaf } from '../../libs/animate';
import PopoverUsuarioDinamico from '../usuarios/PopoverUsuarioDinamico.vue';

const props = defineProps({
  destinatarios: { type: Array, required: true },
  btnEliminar: { type: Boolean, default: true },
  solicitarInformacion: { type: Boolean, default: true },
  inline: { type: Boolean, default: false },
});

const emits = defineEmits(['eliminarDestinatario', 'update:destinatarios']);

const destinatariosInternos = useVModel(props, 'destinatarios', emits, { passive: true });

function eliminar(destinatario) {
  // Esto es para que quite el destinatario de la lista actual y luego lance el evento para que
  // de la impresión de que va rápido y no bloquee la UI.
  destinatariosInternos.value = destinatariosInternos.value.filter((d) => d.id !== destinatario.id);
  doubleRaf(() => {
    emits('eliminarDestinatario', destinatario);
  });
}

const popoverUsuario = ref();
function mostrarPopoverUsuario(destinatario) {
  if (!destinatario.usuario) {
    return;
  }

  popoverUsuario.value.mostrarPopoverUsuario(destinatario.usuario);
}
</script>

<template>
  <div class="destinatarios-wrapper">
    <PopoverUsuarioDinamico
      ref="popoverUsuario"
      target-selector=".destinatario"
      :disabled="!solicitarInformacion"
    >
    </PopoverUsuarioDinamico>
    <ul class="unstyled destinatarios">
      <li
        v-for="destinatario in destinatariosInternos"
        :key="destinatario.id"
        class="destinatario"
        :class="{ inline: inline }"
      >
        <LabelDestinatario
          :destinatario="destinatario"
          :btn-eliminar="btnEliminar"
          class="clickable"
          @eliminar="eliminar($event)"
          @click.prevent.stop="mostrarPopoverUsuario(destinatario)"
        ></LabelDestinatario>
      </li>
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@import "@/../assets/stylesheets/cifra/vars/main.scss";

.destinatarios-wrapper {
  .destinatarios {
    padding-left: 0;
  }
}
</style>
